
const interactioningdesk = (state = [], action) => {
    switch (action.type) {
      case 'ADD_INTERACTION':
      return {
          type: "ADD_INTERACTION",
          payload: action.payload,
        }
      case 'IS_SAVE_INTERACTION':
      if(!state.payload){
        let payload = {
          caseId: action.caseId,
          isSendLog: true
        }
        return {...state, payload}
      }else{
        state.payload.caseId = action.payload.caseId;
        state.payload.isSendLog = true
        return state;
      }
      case 'IS_SAVE_CLIENT_INTERACTION':    
      if(state.payload){
        state.payload.clientId = action.payload.clientId;
      }
      return state;
      case 'REMOVE_INTERACTION':
          return [];
      default:
          return state
    }
  }
  
  export default interactioningdesk